import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useDictionary } from '../contexts/DictionaryContext';
import { Loader } from '../components/common/Loader';
import Card from '../components/common/Card';
import { Briefcase, CheckCircle } from 'lucide-react';

const VinculoSelectionPage = () => {
    // CORREÇÃO: Usando 'vinculos', 'selecionarVinculo' e 'vinculoSelecionado' do nosso AuthContext
    const { vinculos, selecionarVinculo, vinculoSelecionado, loading } = useAuth();
    const { loading: dictionaryLoading, loadDictionary, getDescricao } = useDictionary();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    // Carrega os dicionários necessários para exibir as descrições na tela.
    useEffect(() => {
        loadDictionary('cargos');
        loadDictionary('aux_vinc_admissao_tipo');
    }, [loadDictionary]);

    // O AppRouter já trata o redirecionamento, mas mantemos como uma segurança adicional.
    useEffect(() => {
        if (vinculoSelecionado) {
            navigate('/dashboard');
        }
    }, [vinculoSelecionado, navigate]);

    const handleSelectVinculo = (vinculo) => {
        setIsSubmitting(true);
        try {
            // A função agora recebe o objeto de vínculo completo.
            selecionarVinculo(vinculo);
            // Navega para o dashboard após a seleção bem-sucedida.
            navigate('/dashboard');
        } catch (error) {
            console.error("Erro ao selecionar vínculo:", error);
            setIsSubmitting(false);
        }
    };
    
    // Funções para obter descrições do dicionário de dados.
    const getAdmissaoDescription = (id) => getDescricao('aux_vinc_admissao_tipo', id);
    const getCargoDescription = (id) => getDescricao('cargos', id);

    if (loading || dictionaryLoading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <Loader />
            </div>
        );
    }
    
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-4">
            <div className="w-full max-w-2xl p-8 space-y-6 bg-white dark:bg-gray-800 rounded-lg shadow-md text-center">
                <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                    Seleção de Vínculo
                </h2>
                <p className="text-gray-600 dark:text-gray-400">
                    Foi detectado mais de um vínculo ativo. Por favor, selecione qual deles você deseja acessar.
                </p>

                <div className="space-y-4">
                    {/* CORREÇÃO: Mapeando a lista de 'vinculos' do nosso context */}
                    {vinculos && vinculos.map(vinculo => (
                        <Card 
                            key={vinculo.id} // Usando o ID do documento como chave
                            className="transition-all duration-200 border border-gray-200 dark:border-gray-700 hover:shadow-lg"
                        >
                            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-left">
                                <div>
                                    <div className="flex items-center mb-2">
                                        <Briefcase className="w-5 h-5 text-blue-500 mr-3" />
                                        <p className="font-bold text-lg text-gray-800 dark:text-gray-200">{getCargoDescription(vinculo.cargo_id) || vinculo.descricao}</p>
                                    </div>
                                    <div className="text-sm text-gray-600 dark:text-gray-400 space-y-1 pl-8">
                                        <p><span className="font-semibold">Matrícula:</span> {vinculo.matricula || 'Não informada'}</p>
                                        <p><span className="font-semibold">Admissão:</span> {vinculo.admissao_data || 'Não informada'}</p>
                                        <p><span className="font-semibold">Tipo:</span> {getAdmissaoDescription(vinculo.admissao_tipo) || 'Não informado'}</p>
                                    </div>
                                </div>
                                <button
                                    // CORREÇÃO: Passando o objeto 'vinculo' inteiro para o handler
                                    onClick={() => handleSelectVinculo(vinculo)}
                                    disabled={isSubmitting}
                                    className="bg-green-600 text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition-colors flex items-center w-full md:w-auto justify-center disabled:opacity-50"
                                >
                                    <CheckCircle size={18} className="mr-2" />
                                    {isSubmitting ? 'Acessando...' : 'Selecionar'}
                                </button>
                            </div>
                        </Card>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default VinculoSelectionPage;